/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../Types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type DateFieldComparison = {
  between?: DateFieldComparisonBetween | null | undefined;
  eq?: unknown;
  gt?: unknown;
  gte?: unknown;
  in?: Array<unknown> | null | undefined;
  is?: boolean | null | undefined;
  isNot?: boolean | null | undefined;
  lt?: unknown;
  lte?: unknown;
  neq?: unknown;
  notBetween?: DateFieldComparisonBetween | null | undefined;
  notIn?: Array<unknown> | null | undefined;
};

export type DateFieldComparisonBetween = {
  lower: unknown;
  upper: unknown;
};

export type EmailLogFilter = {
  and?: Array<EmailLogFilter> | null | undefined;
  attachments?: EmailLogFilterAttachmentFilter | null | undefined;
  confirmId?: IdFilterComparison | null | undefined;
  confirmedAt?: DateFieldComparison | null | undefined;
  createdAt?: DateFieldComparison | null | undefined;
  currentStatus?: NotificationStatusFilterComparison | null | undefined;
  feedEntryId?: IdFilterComparison | null | undefined;
  from?: StringFieldComparison | null | undefined;
  id?: IdFilterComparison | null | undefined;
  notificationId?: IdFilterComparison | null | undefined;
  numberOfAttempts?: NumberFieldComparison | null | undefined;
  or?: Array<EmailLogFilter> | null | undefined;
  providerStatus?: NotificationStatusFilterComparison | null | undefined;
  recipientName?: StringFieldComparison | null | undefined;
  recipientUserGroupId?: IdFilterComparison | null | undefined;
  recipientUserGroupName?: StringFieldComparison | null | undefined;
  referenceId?: StringFieldComparison | null | undefined;
  sentAt?: DateFieldComparison | null | undefined;
  template?: EmailLogFilterEmailTemplateFilter | null | undefined;
  templateId?: IdFilterComparison | null | undefined;
  to?: StringFieldComparison | null | undefined;
  updatedAt?: DateFieldComparison | null | undefined;
  userResponse?: StringFieldComparison | null | undefined;
};

export type EmailLogFilterAttachmentFilter = {
  and?: Array<EmailLogFilterAttachmentFilter> | null | undefined;
  createdAt?: DateFieldComparison | null | undefined;
  filename?: StringFieldComparison | null | undefined;
  id?: IdFilterComparison | null | undefined;
  or?: Array<EmailLogFilterAttachmentFilter> | null | undefined;
  updatedAt?: DateFieldComparison | null | undefined;
};

export type EmailLogFilterEmailTemplateFilter = {
  and?: Array<EmailLogFilterEmailTemplateFilter> | null | undefined;
  createdAt?: DateFieldComparison | null | undefined;
  id?: IdFilterComparison | null | undefined;
  or?: Array<EmailLogFilterEmailTemplateFilter> | null | undefined;
  title?: StringFieldComparison | null | undefined;
  type?: EmailTemplateTypeFilterComparison | null | undefined;
  updatedAt?: DateFieldComparison | null | undefined;
};

/** EmailTemplateType */
export type EmailTemplateType =
  | 'FEED'
  | 'STANDARD';

export type EmailTemplateTypeFilterComparison = {
  eq?: EmailTemplateType | null | undefined;
  gt?: EmailTemplateType | null | undefined;
  gte?: EmailTemplateType | null | undefined;
  iLike?: EmailTemplateType | null | undefined;
  in?: Array<EmailTemplateType> | null | undefined;
  is?: boolean | null | undefined;
  isNot?: boolean | null | undefined;
  like?: EmailTemplateType | null | undefined;
  lt?: EmailTemplateType | null | undefined;
  lte?: EmailTemplateType | null | undefined;
  neq?: EmailTemplateType | null | undefined;
  notILike?: EmailTemplateType | null | undefined;
  notIn?: Array<EmailTemplateType> | null | undefined;
  notLike?: EmailTemplateType | null | undefined;
};

export type IdFilterComparison = {
  eq?: string | number | null | undefined;
  gt?: string | number | null | undefined;
  gte?: string | number | null | undefined;
  iLike?: string | number | null | undefined;
  in?: Array<string | number> | null | undefined;
  is?: boolean | null | undefined;
  isNot?: boolean | null | undefined;
  like?: string | number | null | undefined;
  lt?: string | number | null | undefined;
  lte?: string | number | null | undefined;
  neq?: string | number | null | undefined;
  notILike?: string | number | null | undefined;
  notIn?: Array<string | number> | null | undefined;
  notLike?: string | number | null | undefined;
};

/** Notification Status */
export type NotificationStatus =
  | 'ANSWERING_MACHINE'
  | 'BUSY'
  | 'CANCELED'
  | 'COMPLETED'
  | 'CONFIRMED'
  | 'FAILED'
  | 'FAX_MACHINE'
  | 'IN_PROGRESS'
  | 'NO_ANSWER'
  | 'NO_INPUT'
  | 'PREVIEW'
  | 'PREVIEW_COMPLETED'
  | 'QUEUED'
  | 'REJECTED'
  | 'UNAVAILABLE';

export type NotificationStatusFilterComparison = {
  eq?: NotificationStatus | null | undefined;
  gt?: NotificationStatus | null | undefined;
  gte?: NotificationStatus | null | undefined;
  iLike?: NotificationStatus | null | undefined;
  in?: Array<NotificationStatus> | null | undefined;
  is?: boolean | null | undefined;
  isNot?: boolean | null | undefined;
  like?: NotificationStatus | null | undefined;
  lt?: NotificationStatus | null | undefined;
  lte?: NotificationStatus | null | undefined;
  neq?: NotificationStatus | null | undefined;
  notILike?: NotificationStatus | null | undefined;
  notIn?: Array<NotificationStatus> | null | undefined;
  notLike?: NotificationStatus | null | undefined;
};

export type NumberFieldComparison = {
  between?: NumberFieldComparisonBetween | null | undefined;
  eq?: number | null | undefined;
  gt?: number | null | undefined;
  gte?: number | null | undefined;
  in?: Array<number> | null | undefined;
  is?: boolean | null | undefined;
  isNot?: boolean | null | undefined;
  lt?: number | null | undefined;
  lte?: number | null | undefined;
  neq?: number | null | undefined;
  notBetween?: NumberFieldComparisonBetween | null | undefined;
  notIn?: Array<number> | null | undefined;
};

export type NumberFieldComparisonBetween = {
  lower: number;
  upper: number;
};

export type StringFieldComparison = {
  eq?: string | null | undefined;
  gt?: string | null | undefined;
  gte?: string | null | undefined;
  iLike?: string | null | undefined;
  in?: Array<string> | null | undefined;
  is?: boolean | null | undefined;
  isNot?: boolean | null | undefined;
  like?: string | null | undefined;
  lt?: string | null | undefined;
  lte?: string | null | undefined;
  neq?: string | null | undefined;
  notILike?: string | null | undefined;
  notIn?: Array<string> | null | undefined;
  notLike?: string | null | undefined;
};

export type UpdateEmailLogInput = {
  confirmedAt?: unknown;
  userResponse?: string | null | undefined;
};

export type GetEmailLogsQueryVariables = Exact<{
  filter?: Types.EmailLogFilter | null | undefined;
}>;


export type GetEmailLogsQuery = { emailLogs: { edges: Array<{ node: { id: string, recipientId: string | null, confirmedAt: unknown } }> } };

export type UpdateEmailLogMutationVariables = Exact<{
  id: string | number;
  newState: Types.UpdateEmailLogInput;
}>;


export type UpdateEmailLogMutation = { updateOneEmailLog: { id: string } };


export const GetEmailLogsDocument = gql`
    query getEmailLogs($filter: EmailLogFilter) {
  emailLogs(filter: $filter) {
    edges {
      node {
        id
        recipientId
        confirmedAt
      }
    }
  }
}
    `;

/**
 * __useGetEmailLogsQuery__
 *
 * To run a query within a React component, call `useGetEmailLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailLogsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetEmailLogsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEmailLogsQuery, GetEmailLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEmailLogsQuery, GetEmailLogsQueryVariables>(GetEmailLogsDocument, options);
      }
export function useGetEmailLogsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEmailLogsQuery, GetEmailLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEmailLogsQuery, GetEmailLogsQueryVariables>(GetEmailLogsDocument, options);
        }
// @ts-ignore
export function useGetEmailLogsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetEmailLogsQuery, GetEmailLogsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetEmailLogsQuery, GetEmailLogsQueryVariables>;
export function useGetEmailLogsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEmailLogsQuery, GetEmailLogsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetEmailLogsQuery | undefined, GetEmailLogsQueryVariables>;
export function useGetEmailLogsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEmailLogsQuery, GetEmailLogsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetEmailLogsQuery, GetEmailLogsQueryVariables>(GetEmailLogsDocument, options);
        }
export type GetEmailLogsQueryHookResult = ReturnType<typeof useGetEmailLogsQuery>;
export type GetEmailLogsLazyQueryHookResult = ReturnType<typeof useGetEmailLogsLazyQuery>;
export type GetEmailLogsSuspenseQueryHookResult = ReturnType<typeof useGetEmailLogsSuspenseQuery>;
export type GetEmailLogsQueryResult = Apollo.QueryResult<GetEmailLogsQuery, GetEmailLogsQueryVariables>;
export const UpdateEmailLogDocument = gql`
    mutation UpdateEmailLog($id: ID!, $newState: UpdateEmailLogInput!) {
  updateOneEmailLog(input: {id: $id, update: $newState}) {
    id
  }
}
    `;

/**
 * __useUpdateEmailLogMutation__
 *
 * To run a mutation, you first call `useUpdateEmailLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailLogMutation, { data, loading, error }] = useUpdateEmailLogMutation({
 *   variables: {
 *      id: // value for 'id'
 *      newState: // value for 'newState'
 *   },
 * });
 */
export function useUpdateEmailLogMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEmailLogMutation, UpdateEmailLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateEmailLogMutation, UpdateEmailLogMutationVariables>(UpdateEmailLogDocument, options);
      }
export type UpdateEmailLogMutationHookResult = ReturnType<typeof useUpdateEmailLogMutation>;
export type UpdateEmailLogMutationResult = Apollo.MutationResult<UpdateEmailLogMutation>;
export type UpdateEmailLogMutationOptions = Apollo.BaseMutationOptions<UpdateEmailLogMutation, UpdateEmailLogMutationVariables>;